const sortable = require('html5sortable/dist/html5sortable.cjs.js');

const $inject = ['$scope', '$routeParams', '$timeout', 'dataService'];

const lbaRemarksEditorCtrl = function (
    $scope,
    $routeParams,
    $timeout,
    dataService
) {
    const vm = this;

    const dataLookUp = dataService.spiltDataAt(
        vm.settings.dataAt,
        $routeParams
    );

    vm.activeEditableIndex = null;
    vm.data = _.get(dataService.data.activeItem, dataLookUp);
    vm.randomId = _.random(0, 1000000);
    vm.isSorting = false;
    vm.sortable = null;
    vm.activeRemark = null;
    vm.showEditAll = false;
    vm.editAllModel = null;

    let addNewMode = false;
    let id = `.sortable-${vm.randomId}`;
    let canCopy = false;

    handleSortable();

    function sortTimeout() {
        $timeout(() => {
            sortable(id);
        });
    }

    vm.handleEdit = function handleEdit(remarkIndex) {
        vm.activeEditableIndex = remarkIndex;
        vm.activeRemark = vm.data[remarkIndex];

        sortTimeout();
    };

    vm.handleCancel = function handleCancel() {
        if (addNewMode && vm.activeRemark.length === 0) {
            addNewMode = false;
            return vm.handleRemove(vm.activeEditableIndex);
        }
        vm.activeEditableIndex = null;
        vm.activeRemark = null;

        sortTimeout();
    };

    vm.handleRemove = function handleRemove(remarkIndex) {
        vm.data.splice(remarkIndex, 1);
        vm.activeEditableIndex = null;
        vm.activeRemark = null;

        sortTimeout();
    };

    vm.handleDone = function handleDone() {
        if (vm.activeRemark.length === 0)
            return vm.handleRemove(vm.activeEditableIndex);

        vm.data[vm.activeEditableIndex] = vm.activeRemark;
        vm.activeEditableIndex = null;
        vm.activeRemark = null;
        let newData = vm.data.join(',');
        vm.data = newData.split(',');
        
        sortTimeout();
    };

    function handleSortable() {
        $timeout(() => {
            sortable(id, {
                forcePlaceholderSize: true,
                handle: '.fa-sort',
            });

            sortable(id)[0].addEventListener('sortupdate', function (e) {
                let from = e.detail.origin.elementIndex;
                let to = e.detail.destination.elementIndex;
                var itemToMove = vm.data[from];
                vm.data.splice(from, 1);
                vm.data.splice(to, 0, itemToMove);

                $scope.$apply();
            });
        });
    }

    vm.copyAll = function copyAll() {
        if (!canCopy)
            console.alert(
                'Sorry, your browser if blocking the copy all command'
            );

        let text = vm.data.join(',');
        navigator.clipboard.writeText(text).then(
            function () {
                console.log('Copying text command was successful');
            },
            function () {
                console.alert('Sorry, copy all command was unsuccessful');
            }
        );
    };

    
    vm.editAll = function editAll() {
        vm.showEditAll = true;
        vm.editAllModel = vm.data.join(',');
    };

    vm.handleCancelEditAll = function handleCancelEditAll() {
        vm.showEditAll = false;

        sortTimeout();
    };

    vm.handleDoneEditAll = function handleDoneEditAll() {
        vm.showEditAll = false;
        vm.data = vm.editAllModel.split(',');

        handleSortable();
    };

    vm.addNew = function addNew() {
        addNewMode = true;
        vm.data = [...vm.data, ''];
        vm.handleEdit(vm.data.length - 1);
    };

    navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
        if (result.state == 'granted' || result.state == 'prompt') {
            canCopy = true;
        }
    });

    $scope.$watchCollection('vm.data', (newData, oldData) => {
        if (newData !== oldData) {
            _.set(dataService.data.activeItem, dataLookUp, newData);
        }
    });
};

lbaRemarksEditorCtrl.$inject = $inject;

export default lbaRemarksEditorCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaRemarksEditor/lbaRemarksEditorCtrl.js